// The account-wide reference data most widgets render against.
const SOURCES = {
	eventTypes: host => host.tryFetch('eventTypes', 'eventTypes'),
	giftTypes: host => host.tryFetch('giftTypes', 'giftTypes', r => r?.results || []),
	giftThresholds: host => host.tryFetch('giftThresholds', 'giftThresholds'),
	textReplacements: host => host.tryFetch('textReplacements', 'textReplacements'),
	serviceIcons: host => host.tryFetch('services', 'serviceIcons'),
	userData: host => host.tryFetch('userData', 'userData'),
};

const DEFAULTS = { eventTypes: [], giftTypes: [], giftThresholds: [], textReplacements: {}, serviceIcons: [], userData: null };

export async function loadWidgetData(host, names) {
	const [ settings, ...values ] = await Promise.all([ host.loadSettings(), ...names.map(n => SOURCES[n](host)) ]);
	return { settings: settings || {}, ...Object.fromEntries(names.map((n, i) => [ n, values[i] || DEFAULTS[n] ])) };
}

export function applyWidgetData(widget, d) {
	if('settings' in d) widget.applySettings(d.settings);
	if('eventTypes' in d) widget.applyEventTypes(d.eventTypes);
	if('giftTypes' in d) widget.applyGiftTypes(d.giftTypes);
	if('giftThresholds' in d) widget.applyGiftThresholds(d.giftThresholds);
	if('textReplacements' in d) widget.applyTextReplacements(d.textReplacements);
	if('serviceIcons' in d) widget.applyServiceIcons(d.serviceIcons);
	if(d.userData) widget.applyUserData(d.userData);
}

export const RELOAD_INTERVAL = 5 * 60 * 1000;
